export default "__VITE_ASSET__DYZM0jWR__"